import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

import useIFramePostMessage from './useIFramePostMessage';

interface AutoAcceptPriceChanges {
  autoAcceptPriceChanges: boolean;
}

const updateAutoAcceptPriceEventType = 'updateAutoAcceptPrice';

const useAutoAcceptPriceChanges = () => {
  const isClientAuthenticated = useSelector(select.session.isClientAuthenticated);

  const {
    account: { fetch, updateAccount }
  } = useDispatch<Dispatch>();

  const eventListener = () => fetch();

  const { postMessage } = useIFramePostMessage(updateAutoAcceptPriceEventType, eventListener);

  const setAutoAcceptPriceChanges = useCallback(
    async ({ autoAcceptPriceChanges }: AutoAcceptPriceChanges) => {
      if (isClientAuthenticated) {
        await updateAccount({ autoAcceptPriceChanges });

        postMessage();
      }
    },
    [isClientAuthenticated, postMessage, updateAccount]
  );

  return { setAutoAcceptPriceChanges };
};

export default useAutoAcceptPriceChanges;
